# Giochi di Fibonacci 2025/2026

## Fase II - Scuole primarie

Questa prova contiene _5 problemi_ da risolvere in _120 minuti_, ed è divisa in due parti:
- due problemi di interpretazione di **procedimenti procedurali**.
- tre problemi di **pensiero logico-algoritmico** come programmi a blocchi.

In tutte e due le parti i problemi sono ordinati per difficoltà crescente.
**Fai attenzione, la difficoltà è soggettiva:** se stai passando tanto tempo cercando di risolvere un problema, prova a passare ad altri problemi e altre categorie.

**Attento! non devi uscire dalla piattaforma di gara** per nessun motivo!

Puoi invece usare calcolatrici, fogli e materiale da cancelleria.

## Punteggio

### Procedimenti procedurali

Questi problemi comprendono _due domande_, valutate separatamente.
La prima domanda è **sempre più semplice**, e può aiutare a rispondere alla seconda domanda.
Le domande sono tutte a **scelta multipla** con 5 opzioni, di cui **solo una** è corretta. Il punteggio che puoi ottenere è:

- 5 punti per una risposta _corretta_;
- 1 punto per una risposta _non data_;
- 0 punti per una risposta _sbagliata_.

### Programmazione a blocchi

Questi problemi richiedono di scrivere un **singolo** programma a blocchi, che viene valutato **contemporaneamente** su quattro diversi livelli.
Quindi attenzione che non puoi scrivere programmi diversi per i diversi livelli, ma uno solo che deve funzionare per più livelli possibile!
Per ciascun problema e per ciascun livello, Il punteggio che puoi ottenere è:

- 5 punti se il tuo programma produce la risposta _corretta_ su quel livello;
- 0 punti se il tuo programma produce una risposta _sbagliata_ su quel livello.

Quindi ogni domanda a blocchi può valere fino a 20 punti in totale.
